import React from 'react';
import { IconStar } from './Icons';

export default function Stars({ value = 5, size = 14, className = '' }) {
  return (
    <span className={`eg-stars inline-flex items-center ${className}`} aria-label={`${value} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <IconStar key={n} filled={n <= Math.round(value)} width={size} height={size} />
      ))}
    </span>
  );
}
